// src/pages/ProfilePage.js
import React from 'react';

const ProfilePage = () => {
  return (
    <div>
      <h1>My Profile</h1>
      <p>Profile details go here.</p>
    </div>
  );
};

export default ProfilePage;
